import React from 'react';
import { Select, SelectOption } from '@flixbus/honeycomb-react';

import { Asterisk } from '../../Asterisk';
import { ROLES } from '../../../../types/Roles';
import { useVoucherFormContext } from '../../Context';
import { useRoles } from '../../../../context/RolesProvider';

const VoucherFormUsageType: React.FC<{ usageType: string }> = ({ usageType }) => {
  const {
    formState: {
      payload: { multiUsage },
    },
    handleUsageTypeChange,
  } = useVoucherFormContext();

  const { isLoading, error, hasAnyRole } = useRoles();

  const disabled =
    isLoading ||
    error !== null ||
    !hasAnyRole([ROLES.ROLE_VOUCHER_PORTAL_ADMIN, ROLES.ROLE_CREATE_MULTI_MARKETING_VOUCHER]);

  const handleValueChange = (value: string) => {
    handleUsageTypeChange(value);
  };

  return (
    <Select
      disabled={disabled}
      id='usage-type'
      value={multiUsage ? 'multiple' : 'single'}
      label={<>Usage type {!usageType && <Asterisk />}</>}
      onChange={e => handleValueChange(e.target.value)}
    >
      <SelectOption value='single'>Single</SelectOption>
      <SelectOption value='multiple'>Multiple</SelectOption>
    </Select>
  );
};

export default VoucherFormUsageType;
